// extracted by mini-css-extract-plugin
export default {"bg":"landing_bg__VFB4O","bgImage":"landing_bgImage__MUfiX","h":"landing_h__l+ZMS","btn":"landing_btn__F7DIf"};